import React from 'react'
import styled from 'styled-components/native'
import { ProximaNova } from '../../../../App/Components'

type Props = {
  isShowDuration: boolean
  isShowPrice: boolean
  duration: number
  waitTime: number
  fontColor?: string
}

const DurationText = styled(ProximaNova)<{ color: string }>`
  font-size: 1em;
  width: 50%;
  max-width: 71px;
  color: ${({ color }) => color || '#fff'};
`

export const ActivityDuration = ({
  isShowDuration,
  duration,
  waitTime,
  fontColor,
}: Props) => {
  if (!isShowDuration || !duration) {
    return null
  }

  const totalTime = duration + waitTime

  return <DurationText color={fontColor}>{`${totalTime} min`}</DurationText>
}
